<div class="header-actions" *ngIf="actions | async as actions">
    <div *ngFor="let ele of actions.data; trackBy: trackByElementId">
        <surveys-render-survey-element
            [element]="ele"
            [matchChildHeight]="'false'"
        ></surveys-render-survey-element>
    </div>
</div>